import {
  TrackingMethod,
  type TrackingMethod as TrackingMethodType,
  TrackingProvider,
  type TrackingProvider as TrackingProviderType,
} from './Tracking'

export type PreferredTrackingMethod = {
  provider?: TrackingProviderType
  method?: TrackingMethodType
}

export function getProvidersForMethod(method?: TrackingMethod) {
  switch (method) {
    case TrackingMethod.ELD:
      return [TrackingProvider.P44, TrackingProvider.TT]
    case TrackingMethod.EDI:
      return []
    case TrackingMethod.API:
      return [TrackingProvider.P44]
    case TrackingMethod.Mobile:
      return [TrackingProvider.P44, TrackingProvider.TT, TrackingProvider.Loadsmart]
    default:
      return []
  }
}
